import React from 'react';
import { FormattedMessage } from 'react-intl';

const DepartureRowHeader = () => (
  <tr className="departure-row">
    <th className="time-cell">
      <FormattedMessage id="route-time-header" defaultMessage="Time" />
    </th>
    <th className="route-number-container" style={{ background: 'none' }}>
      <FormattedMessage id="route-number-header" defaultMessage="Route" />
    </th>
    <th className="route-headsign">
      <FormattedMessage id="route-headsign-header" defaultMessage="Direction" />
    </th>
  </tr>
);

export default DepartureRowHeader;
